// extracted by mini-css-extract-plugin
export default {"defaultButton":"Button_defaultButton__+8knT"};